import React from "react";
import { Button, Card, Form, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Label } from "reactstrap";
import Moment from "moment";
import "moment/locale/id";

function Step2() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  Moment.locale("id");
  const tglLahirPasangan = !valDetail?.stepDua?.tglLahirPasangan
    ? "-"
    : Moment(valDetail.stepDua.tglLahirPasangan).format("DD MMMM YYYY");
  return (
    <div className="mt-4">
      <h4
        style={{
          fontWeight: "800",
          textTransform: "uppercase",
          color: "#2C3E50",
          fontSize: "18px",
          marginBottom: "20px",
          paddingBottom: "12px",
          borderBottom: "2px solid #f0f0f0"
        }}
      >
        Informasi Pasangan
      </h4>
      <div style={{ maxHeight: "550px", overflowY: "auto", overflowX: "hidden", padding: "5px" }}>
        <Row>
          {[
            {
              label: "nama pasangan",
              value: valDetail?.stepDua?.namaPasangan,
            },
            {
              label: "no ktp pasangan",
              value: valDetail?.stepDua?.noKtpPasangan,
            },
            {
              label: "no. handphone",
              value: valDetail?.stepDua?.noHpPasangan,
            },
            { label: "tanggal lahir pasangan", value: tglLahirPasangan },
            {
              label: "alamat pasangan",
              value: valDetail?.stepDua?.alamatPasangan,
            },
            {
              label: "tempat lahir pasangan",
              value: valDetail?.stepDua?.tempatLahirPasangan,
            },
            {
              label: "nip pasangan",
              value: valDetail?.stepDua?.nipPasangan,
            },
            {
              label: "npwp pasangan",
              value: valDetail?.stepDua?.npwpPasangan,
            },
            {
              label: "sedang bekerja",
              value:
                valDetail?.stepDua?.sedangBekerja === "true"
                  ? "Ya"
                  : valDetail?.stepDua?.sedangBekerja === "false"
                    ? "Tidak"
                    : null,
            },
            {
              label: "nama pekerjaan",
              value: valDetail?.stepDua?.namaPekerjaan,
            },
            {
              label: "nama instansi",
              value: valDetail?.stepDua?.namaInstansi,
            },
            {
              label: "alamat pekerjaan",
              value: valDetail?.stepDua?.alamatPekerjaan,
            },
            {
              label: "telepon kantor",
              value: valDetail?.stepDua?.telpKantor,
            },
            {
              label: "alamat kantor",
              value: valDetail?.stepDua?.alamatKantor,
            },
            {
              label: "pangkat golongan",
              value: valDetail?.stepDua?.pangkatGolongan,
            },
            { label: "jabatan", value: valDetail?.stepDua?.jabatan },
            {
              label: "awal bekerja",
              value: valDetail?.stepDua?.awalBekerja,
            },
          ].map((item, index) => (
            <Col xs={12} sm={6} lg={4} key={index} className="mb-3">
              <div 
                style={{ 
                  padding: "16px 20px", 
                  backgroundColor: "#F8FAFC", 
                  borderRadius: "14px", 
                  height: "100%", 
                  border: "1px solid #E2E8F0",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#F0F9FF";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(14, 165, 233, 0.12)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.borderColor = "#BAE6FD";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F8FAFC";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#E2E8F0";
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#64748B",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px"
                  }}
                >
                  {item.label}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#1E293B",
                    fontWeight: "600",
                    textTransform: "capitalize",
                    wordBreak: "break-word",
                    lineHeight: "1.4"
                  }}
                >
                  {item.value && item.value !== "" ? item.value : <span style={{ color: "#CBD5E1" }}>-</span>}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
export default Step2;
